var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FormProvider } from '../context';
var withForm = function (config) {
    if (config === void 0) { config = {}; }
    return function (Component) {
        var WithForm = function (props) {
            var _a = props, _b = config.initialValues || 'initialValues', initialValues = _a[_b], _c = config.rules || 'rules', rules = _a[_c], _d = config.refs || 'refs', refs = _a[_d];
            return (_jsx(FormProvider, __assign({ initialValues: initialValues, rules: rules, refs: refs }, { children: _jsx(Component, __assign({}, props), void 0) }), void 0));
        };
        return WithForm;
    };
};
export default withForm;
//# sourceMappingURL=withForm.js.map